<template>
    <div>
        <div class="flex p-4" @click="clickNotiItem()">
            <div class="w-2/5">
                <div v-if="notiItem.objectType == 'badge'"
                    class="campaign-image rounded-md"
                    :style="{'background-image': `url('${notiItem.fullImageUrl}?disable=true')`}">
                </div>
                <div v-if="notiItem.objectType == 'cat' ||
                        notiItem.objectType == 'comment'">
                    <img src="../../../assets/logo/logo2.png" alt=""/>
                </div>

                <div v-if="notiItem.objectType != 'badge'
                    && notiItem.objectType != 'comment'
                    && notiItem.objectType != 'cat'
                    && !notiItem.fullImageUrl"
                >
                    <div class="campaign-logo"></div>
                </div>

                <div v-if="notiItem.objectType != 'badge'
                    && notiItem.objectType != 'comment'
                    && notiItem.objectType != 'cat'
                    && notiItem.fullImageUrl"
                    class="campaign-image rounded-md"
                    :style="{'background-image': `url('${notiItem.fullImageUrl}?disable=true')`}">
                </div>
            </div>
            <div class="w-3/5 pl-4 flex flex-col">
                <div v-if="notiItem.objectType == 'badge'"
                    class="campaign-name text-a-blue-0069a8 text-20 font-semibold">{{notiItem.name}}</div>

                <div v-if="notiItem.objectType != 'comment'"
                    class="campaign-name text-a-blue-0069a8 text-20 font-semibold">
                    {{notiItem.objectType != 'badge' ? notiItem.message : (notiItem.fb_message ? notiItem.fb_message : notiItem.message)}}
                </div>
                <div v-if="notiItem.objectType == 'comment'"
                    class="campaign-name text-a-blue-0069a8 text-20 font-semibold">แอดมินได้แสดงความคิดเห็นบนโพสของคุณ</div>
                <div class="mt-auto text-18 text-a-gray-666666">{{converseDate(notiItem.createTime)}}</div>
            </div>
        </div>
    </div>
</template>
<script>
//Helper
import DatetimeHelper from "@/helper/DatetimeHelper.js";

export default {
    name: "notiitem",
    props: {
        notiItem: { type: Object, required: true },
    },
    created: function () {

    },
    methods: {
        converseDate: function (time) {
            return DatetimeHelper.getDatetimeFullFormatNoti(time);
        },
        clickNotiItem: function () {
            this.$emit('clickNotiItem', this.notiItem);
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    @import "@/style/base/image.scss";
    .campaign-name {
        min-height: 48px;
        @extend %ellipsis-3;
    }
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
    .campaign-logo {
        background-image: url("../../../assets/logo/logo2.png");
        @include boxRatio($ratio: 66.66%);
        background-size: 100px;
    }
</style>
